module.exports = __webpack_public_path__ + "static/img/logo_sprite.a32d7b7.png";